// reimplementation of jQuery's show and hide that respect the element's original `display` property

// > This is roughly equivalent to calling .css( "display", "block" ),
// > except that the display property is restored to whatever it was initially.
// > If an element has a display value of inline, then is hidden and shown,
// > it will once again be displayed inline.

function show(element) {
  if (element.dataset.previousDisplayValue && element.dataset.previousDisplayValue !== 'none') {
    element.style.display = element.dataset.previousDisplayValue
    element.dataset.previousDisplayValue = null
  } else {
    element.style.display = 'block'
  }
}

function hide(element) {
  const previousDisplayValue = window.getComputedStyle(element).display
  element.dataset.previousDisplayValue = previousDisplayValue
  element.style.display = 'none'
}

export { show, hide }
